// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1741":"a91e9280f0955828","2888":"12a89ff3119f6d1e"}[chunkId] + ".css";
};